import { addJitter, createExponentialRetryStrategy, withRetries } from '@genially/utils';

import { calculateServerIndex } from './calculateServerIndex';

export const waitUntilGetServerIndex = async (value: string): Promise<number> => {
  return withRetries(
    () => {
      return calculateServerIndex(value, { force: true });
    },
    addJitter(
      createExponentialRetryStrategy({
        step: 1000,
        max: 4000,
        multiplier: 2,
        shouldRetryError() {
          return true;
        },
      }),
      {
        min: 0.5,
        max: 1,
      },
    ),
    false,
  );
};
